"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const react_helmet_1 = __importDefault(require("react-helmet"));
const Select_1 = __importDefault(require("@App/kit/components/Selectors/Select"));
const PointPreloader_1 = __importDefault(require("@App/kit/components/Preloaders/PointPreloader"));
const contexts_1 = require("@App/contexts");
const mobx_react_1 = require("mobx-react");
const ContentHeader_1 = __importDefault(require("@Components/ContentHeader"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const react_error_boundary_1 = require("react-error-boundary");
const RatesTable_1 = __importDefault(require("@Components/RoyaltiesTable/RatesTable"));
const ProvisionalRateSheetFooter_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderRoyaltiesRateSheets/ProvisionalRateSheetFooter"));
const RightsholderRoyaltiesRateSheets = () => {
    var _a, _b;
    const { statementsStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [selectedUsagePeriod, selectUsagePeriod] = (0, react_1.useState)();
    const [selectedDsp, selectDSP] = (0, react_1.useState)();
    const handleError = (0, react_error_boundary_1.useErrorHandler)();
    const onSelectedUsagePeriod = (value) => {
        var _a;
        const foundSheetMonth = (_a = statementsStore.ratePeriods) === null || _a === void 0 ? void 0 : _a.find((rateSheetMonth) => rateSheetMonth.period === value.value);
        if (foundSheetMonth) {
            selectUsagePeriod({ option: value, sheetMonth: foundSheetMonth });
        }
        else {
            handleError(new Error('Unable to select sheet month'));
        }
    };
    (0, react_1.useEffect)(() => {
        setLoading(true);
        (0, analytics_utils_1.analyticsSendPage)('rightsholder_royalties_rate_sheets');
        Promise.all([
            statementsStore.ratePeriods ? Promise.resolve() : statementsStore.loadRateSheetPeriods(),
            statementsStore.rateDsps ? Promise.resolve : statementsStore.loadRateSheetDsps(),
        ])
            .then(() => {
            onSelectedUsagePeriod(statementsStore.rateSheetUsagePeriodOptions[0]);
            selectDSP(statementsStore.rateSheetDspOptions[0]);
        })
            .finally(() => setLoading(false));
    }, []);
    (0, react_1.useEffect)(() => {
        if (selectedUsagePeriod && selectedDsp) {
            statementsStore.clearDspRates();
            setLoading(true);
            statementsStore
                .loadDspRates(selectedUsagePeriod.sheetMonth.year.toString(), selectedUsagePeriod.sheetMonth.month.toString(), selectedDsp.value !== 'All' ? selectedDsp.value : undefined)
                .finally(() => setLoading(false));
        }
    }, [selectedUsagePeriod, selectedDsp]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'Royalty Statements' }),
        react_1.default.createElement("div", { className: "rate-sheets-wrapper" },
            react_1.default.createElement("div", { className: 'global-container' },
                react_1.default.createElement(ContentHeader_1.default, { title: 'DSP Rate Sheets', descriptionElement: react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("p", null, "Rate sheets illustrate how a digital service provider (DSP) calculates the rate per unit. The rate per unit is the mechanical royalty rate that is applied to each stream based on subscription type and usage period."),
                        react_1.default.createElement("p", null, "Rate sheets are not unique to your account."),
                        react_1.default.createElement("p", null, "Select the DSP and usage period from the drop-down menus below to view those rate sheets.")) }),
                react_1.default.createElement("div", { className: 'filter-block' },
                    react_1.default.createElement("div", { className: 'filter-item-wrapper' },
                        react_1.default.createElement("div", { className: 'filter-item', "data-testid": 'dsp-options-div' },
                            react_1.default.createElement("p", { className: 'small bold' },
                                react_1.default.createElement("label", { htmlFor: 'dsp-options' }, "DSP:")),
                            react_1.default.createElement(Select_1.default, { name: 'dsp-options', options: statementsStore.rateSheetDspOptions, isDisabled: loading, defaultValue: statementsStore.rateSheetDspOptions[0], selectedValue: selectedDsp, onValueChange: (value) => selectDSP(value) }))),
                    react_1.default.createElement("div", { className: 'filter-item-wrapper' },
                        react_1.default.createElement("div", { className: 'filter-item', "data-testid": 'usage-options-div' },
                            react_1.default.createElement("p", { className: 'small bold' },
                                react_1.default.createElement("label", { htmlFor: 'usage-period-options' }, "Usage Period:")),
                            react_1.default.createElement(Select_1.default, { name: 'usage-period-options', isDisabled: loading, options: statementsStore.rateSheetUsagePeriodOptions, defaultValue: statementsStore.rateSheetUsagePeriodOptions[0], selectedValue: selectedUsagePeriod === null || selectedUsagePeriod === void 0 ? void 0 : selectedUsagePeriod.option, onValueChange: onSelectedUsagePeriod })))),
                loading ? (react_1.default.createElement(PointPreloader_1.default, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(RatesTable_1.default, { data: (_a = statementsStore.dspRates) !== null && _a !== void 0 ? _a : [], isProvisional: (_b = selectedUsagePeriod === null || selectedUsagePeriod === void 0 ? void 0 : selectedUsagePeriod.sheetMonth.provisional) !== null && _b !== void 0 ? _b : false }),
                    (selectedUsagePeriod === null || selectedUsagePeriod === void 0 ? void 0 : selectedUsagePeriod.sheetMonth.provisional) && react_1.default.createElement(ProvisionalRateSheetFooter_1.default, null)))))));
};
exports.default = (0, mobx_react_1.observer)(RightsholderRoyaltiesRateSheets);
